// src/components/EquipmentIcon.js
import React from "react";
import { motion } from "framer-motion";

const svgVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.2, delayChildren: 0.2 },
  },
};

const itemVariants = {
  hidden: { pathLength: 0, opacity: 0 },
  visible: {
    pathLength: 1,
    opacity: 1,
    transition: { duration: 1.5, ease: "easeInOut" },
  },
};

const centerVariants = {
    hidden: { scale: 0, opacity: 0},
    visible: { scale: 1, opacity: 1, transition: { duration: 0.5, ease: 'easeOut', delay: 1 }}
}

export default function EquipmentIcon({ gradientId }) {
  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      variants={svgVariants}
      initial="hidden"
      animate="visible"
    >
      {/* 순환 화살표 */}
      <motion.path
        d="M 85,50 A 35,35 0 1 1 75,18"
        fill="none"
        stroke={`url(#${gradientId})`}
        strokeWidth="6"
        strokeLinecap="round"
        variants={itemVariants}
      />
      <motion.path
        d="M 65,18 L 75,18 L 75,28"
        fill="none"
        stroke={`url(#${gradientId})`}
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
        variants={itemVariants}
      />
      {/* 중앙 아이콘 */}
      <motion.rect x="38" y="38" width="24" height="24" rx="4" fill={`url(#${gradientId})`} variants={centerVariants}/>
    </motion.svg>
  );
}